const DEFAULT_MESSAGE_HANDLER_NAME = 'fareharbor';
/**
 * Utility function to broadcast messages to native apps (iOS/Android)
 * This replicates the logic from website/static/js/application/native/services.js
 * To be used in new VueJs components
 * @param {string} type - The event type (e.g., 'fareharbor.native.user.activity')
 * @param {string} messageHandlerName - The message handler name for iOS (optional, defaults to 'fareharbor')
 * @param {Object} message - The message payload (default: {})
 */
export const nativeBroadcast = (type, messageHandlerName, message = {}) => {
  messageHandlerName = messageHandlerName || DEFAULT_MESSAGE_HANDLER_NAME;

  console.info('native: triggering', type, message, messageHandlerName);
  try {
    // iOS: Use webkit message handlers
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers[messageHandlerName]
    ) {
      window.webkit.messageHandlers[messageHandlerName].postMessage(
        JSON.parse(JSON.stringify({ type, ...message })),
      );
      return;
    }
    // Android: Use fhdroid
    if (window.fhdroid) {
      if (message) {
        window.fhdroid.postMessage(type, JSON.stringify(message));
      } else {
        window.fhdroid.postMessage(type);
      }
      return;
    }
    console.warn('native: native client unavailable');
  } catch (error) {
    console.error('native: could not post message');
  }
};
